module.exports = __webpack_public_path__ + "img/barcelona_sant_gervasi_la_bonanova.15d62d0b.jpg";